import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/store'
import treeTransfer from 'el-tree-transfer' // 引入
import ElementUI from 'element-ui';
import { registerMicroApps, start, setDefaultMountApp } from 'qiankun'
import microApps from './micro-app'
// // import 'element-ui/lib/theme-chalk/index.css';
// let hostString = location.host;
// require(`./assets/theme/${hostString=='storetest.maboy.cn'?'orange':'blue'}.css`);
// if(hostString=='storetest.maboy.cn') {
//     // document.body.className = 'custom-orange'
//     document.body.style.setProperty('--main-color', '#F48E15'); //设置肤色变量值-橙色
// }
import VueAwesomeSwiper from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css';
import CKEditor from '@ckeditor/ckeditor5-vue';
import './assets/css/common.css'
import api from './apis/api'
import 'default-passive-events'
// 自定义公共方法 全局引用
import {dateTime} from './util/dateTime.js';
import {toTableTop} from './util/toTableTop'; // 返回列表的头部
import "./util/amountFilter.js";
import "./util/stateORtypeFilter.js"; // 各种状态和类型集合过滤器
import "./util/dateFormateFilter.js";
import "./util/emptyFilter.js";
import {amountChech,integerCheck,PositiveNumberStringWithZero} from './util/amountChech';
import {emailCheck} from './util/emailCheck';
import {telCheck} from './util/telCheck';
import {ElementControls} from './util/ElementControl'; // 元素控制配置信息
import {PowerFilter} from './util/powerFilter'; // 菜单权限的控制
import { returnDomain } from './util/returnDomain.js'; // 根据域名判断样式风格以及跳转域名
import {setCookie,getCookie} from './util/util';
import {showflows} from './util/show';
Vue.prototype.showflows=showflows;
Vue.prototype.ElementControls=ElementControls;
Vue.prototype.dateTime = dateTime;
Vue.prototype.setCookie=setCookie;
Vue.prototype.getCookie=getCookie;
Vue.prototype.toTableTop = toTableTop;
Vue.prototype.amountChech=amountChech;
Vue.prototype.integerCheck=integerCheck;
Vue.prototype.emailCheck=emailCheck;
Vue.prototype.telCheck=telCheck;
Vue.prototype.PowerFilter=PowerFilter;
Vue.prototype.returnDomain=returnDomain;
Vue.prototype.PositiveNumberStringWithZero=PositiveNumberStringWithZero; // 返回正数
import utilInstaller from './util/util_installer'

Vue.use(VueAwesomeSwiper);
Vue.use(treeTransfer);
Vue.use(ElementUI);
Vue.use( CKEditor );
Vue.use(utilInstaller);

router.beforeEach((to, from, next) => {
  if(getCookie('store_sessionId') && !localStorage.getItem('store_sessionId')){
    let store_sessionId = getCookie('store_sessionId') 
    localStorage.setItem('store_sessionId',store_sessionId)
  }  
  if(to.query && to.query.userName && to.query.storeopertype ){
    let autologinstore = {
      userName:to.query.userName,
      storeopertype:to.query.storeopertype,
      flowcode:to.query.flowcode,
      pflowcode:to.query.pflowcode,
      status:to.query.status,
    }
    sessionStorage.setItem('autologinstore',JSON.stringify(autologinstore))
  }
  window.scrollTo(0, 0);
    sessionStorage.setItem('toHref',window.location.href); // 保存回跳的页面路径
    if(sessionStorage.getItem('configKey')) {
        let info = JSON.parse(sessionStorage.getItem('configKey'));
        Vue.prototype.$openobituary = info['openobituary']==1?1:0;
    } else {
        getGlobalConfig();
    }
    let store_sessionId = localStorage.getItem('store_sessionId')
    if (localStorage.getItem('userInfoMd') === '' || localStorage.getItem('userInfoMd') === 'undefined' || localStorage.getItem('userInfoMd') === null || (localStorage.getItem('userInfoMd') && store_sessionId && store_sessionId != getCookie('store_sessionId'))) { // 尚未登录
        localStorage.setItem('store_sessionId','')
        sessionStorage.setItem('configKey','');
        if(localStorage.getItem('pathLogin')) {
            next()
        } else {
            localStorage.setItem('pathLogin','1')
            if(to.query && to.query.userName && to.query.flowcode && to.query.pflowcode){
              next()
            }else{
              router.push({path: '/'});
            }  
        }
    } else {
      if(!sessionStorage.getItem('qydmInfo') || sessionStorage.getItem('qydmInfo') === undefined) {
            getJoinsharepro(); // 调用企业仓分享信息
        };
        if(!sessionStorage.getItem('pcDomainHref') && !sessionStorage.getItem('modDomainHref') && !sessionStorage.getItem('pcPickHref') && !sessionStorage.getItem('modPickHref')) {
            getDomainList(); // 获取域名配置
        };
        againComyinfo(to, next) 
    }
})

/**
* 调用企业仓分享信息
*/
function getJoinsharepro() {
    api.GET_JOINSHAREPRO({}).then(res => {
        if(res.data.status == "200") {
            if(res.data.data && res.data.data !='null') {
                sessionStorage.setItem('qydmInfo',JSON.stringify(res.data.data));
                localStorage.setItem('opensupplyper',res.data.data.opensupplyper)
            }
        } else {
            this.$message({
                type: 'error',
                message: '请拖动滑块验证!'
            })
        }
    })
};

/**
* 获取域名配置
*/
function getDomainList() {
    api.GET_DOMAINLIST({}).then(res => {
        if(res.data.status == "200") {
            if(res.data.data&&res.data.data.length>0) {
                let dataList = res.data.data;
                let pcDomainHref = '';
                let modDomainHref = '';
                let pcPickHref = '';
                let modPickHref = '';
                dataList.forEach(item => {
                    if(item.attsys == 0) {
                        if(item.domaintype == 0) {
                            if(!pcDomainHref) {
                                pcDomainHref = item.reqdomain;
                                sessionStorage.setItem('pcDomainHref',item.reqdomain);
                            }
                        } else {
                            if(!modDomainHref) {
                                modDomainHref = item.reqdomain;
                                sessionStorage.setItem('modDomainHref',item.reqdomain);
                            }
                        }
                    }
                    if(item.attsys == 1) {
                      if(item.domaintype == 0) {
                          if(!pcPickHref&&item.status) {
                              pcPickHref = item.reqdomain;
                              sessionStorage.setItem('pcPickHref',item.reqdomain);
                          }
                      } else {
                          if(!modPickHref&&item.status) {
                              modPickHref = item.reqdomain;
                              sessionStorage.setItem('modPickHref',item.reqdomain);
                          }
                      }
                  }
                })
            }
        } else {
            this.$message({
                type: 'error',
                message: res.data.message
            })
        }
    })
  };
  /**
   * 基础信息没有缓存时，调取方法
   * @param to 路由
   * @param next 路由
   */
  async function againComyinfo(to, next) {
    if (!sessionStorage.getItem('elementsInfo') || sessionStorage.getItem('elementsInfo') === undefined) {
      await getSysconelementsinfo(); // 获取元素配置信息
    };
    if (to.path == '/') {
      if(to.query && to.query.userName && to.query.flowcode && to.query.pflowcode){ //fullpath格式 /?userName=9998tomStore&storeopertype=add&flowcode=fd22ec35ca7e4e47adfbeed9ebad81ae
        let userInfoMd = {};
        if(localStorage.getItem('userInfoMd')){
          userInfoMd = JSON.parse(localStorage.getItem('userInfoMd'));
        }
        if((to.query.pflowcode == '0' && userInfoMd.flowcode == to.query.flowcode) || (to.query.pflowcode != '0' && userInfoMd.flowcode == to.query.pflowcode)){
          const redirectPath = `/SecondaryStores?userName=${to.query.userName}&storeopertype=${to.query.storeopertype}&flowcode=${to.query.flowcode}&status=${to.query.status}`;
          await next(redirectPath)
        }else{
          // const loginPath = `/?userName=${to.query.userName}&storeopertype=${to.query.storeopertype}&flowcode=${to.query.flowcode}&status=${to.query.status}`;
          // await next(loginPath);
          await next();
        }
      }else{
        await next('/HomePage')
      }
    } else {
      await next();
    }
  }
// 元素控制接口
async function getSysconelementsinfo() {
    await api.GET_SYSCONELEMENTSINFO().then((res) => {
        if(res.data.status == "200"){
            sessionStorage.setItem('elementsInfo',JSON.stringify(res.data.data));
        }
    })
};

// 获取全局控制
async function getGlobalConfig() {
    await api.GET_GLOBALCONFIG({configKey:'openobituary'}).then((res) => {
      if (res.data.status == "200") {
        let info = res.data.data;
        Vue.prototype.$openobituary = info['openobituary']==1?1:0;
        sessionStorage.setItem('configKey',JSON.stringify(info));
      }
    })
};

Vue.config.productionTip = false
new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
})
// 给子应用配置加上loader方法
const apps = microApps.map(item => {
  return {
    ...item,
  }
})

registerMicroApps(apps, {
  beforeLoad: app => {
    console.log('before load app.name====>>>>>', app.name)
  },
  beforeMount: [
    app => {
      store.state.common.isQKchild = true
      console.log('[LifeCycle] before mount %c%s', 'color: green;', app.name)
    }
  ],
  afterMount: [
    app => {
      store.state.common.isQKchild = true
      console.log('[LifeCycle] after mount %c%s', 'color: green;', app.name)
    }
  ],
  afterUnmount: [
    app => {
      store.state.common.isQKchild = false
      console.log('[LifeCycle] after unmount %c%s', 'color: green;', app.name)
    }
  ]
})
// setDefaultMountApp(
start({
  prefetch:  'all' ,// 可选，关闭预加载
  singular: true,  //可选，是否为单实例场景，单实例指的是同一时间只会渲染一个微应用。默认为 true
  // sandbox :{strictStyleIsolation: true}//沙箱开启 默认为true
})


// WEBPACK FOOTER //
// ./src/main.js